module.exports = __webpack_public_path__ + "img/avt.4d54c518.png";